import React from "react";
import SignUpLayer from "../../components/General/SignUpLayer";

const SignUpPage = () => {
  return (
    <>

      {/* SignUpLayer */}
      <SignUpLayer />

    </>
  );
};

export default SignUpPage; 
